import PaymentHistory from './PaymentHistoryContainer.vue';

export { PaymentHistory };



// WEBPACK FOOTER //
// ./src/modules/home/paymentHistory/index.js